import { Button, Tooltip, message, Popover, Select, Space } from 'antd'
import React, { useCallback, useState } from 'react'
import { useDispatch } from 'react-redux';
import { setVmGroup } from '../../../Reducers/accounts';

// Группы драйверов/прокси (vm_group). Пересадка аккаунта сюда меняет пул прокси и драйверов.
const VM_GROUPS = ['DE', 'DE-DECODO', 'GOLOGIN', 'US', 'GLOBAL'];

const SetVmGroupButton = ({ record, afterUpdate, title, icon }) => {
  const dispatch = useDispatch();
  const { id, vmGroupName } = record;
  const [open, setOpen] = useState(false);
  const [group, setGroup] = useState(vmGroupName || undefined);
  const [loading, setLoading] = useState(false);

  const apply = useCallback(() => {
    if (!group) { message.warning('Select a group'); return; }
    setLoading(true);
    dispatch(setVmGroup(id, group)).then(() => {
      message.success(`Account ${id} moved to group ${group}`);
      setOpen(false);
      afterUpdate();
    }).catch(error => {
      console.log(error);
      message.error("Can't change account group");
    }).finally(() => setLoading(false));
  }, [dispatch, id, group, afterUpdate]);

  const content = (
    <Space direction="vertical">
      <Select
        style={{ width: 180 }}
        value={group}
        onChange={setGroup}
        options={VM_GROUPS.map(g => ({ value: g, label: g }))}
        placeholder="Target group"
      />
      <Button type="primary" size="small" loading={loading} onClick={apply}>
        Move to group
      </Button>
    </Space>
  );

  return (
    <Popover
      title={`Group (now: ${vmGroupName || '—'})`}
      trigger="click"
      open={open}
      onOpenChange={setOpen}
      content={content}
    >
      <Tooltip placement="topLeft" title={title}>
        <Button icon={icon} />
      </Tooltip>
    </Popover>
  );
};

export default SetVmGroupButton
